export const getClickableAreaCoordinatesInPixels = (
  area: HTMLDivElement,
  event: React.MouseEvent<HTMLDivElement>
) => {
  const rect = area.getBoundingClientRect();

  return {
    x: event.clientX - rect.left,
    y: event.clientY - rect.top,
  };
};
